var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"action-page"},[(_vm.feedback.type)?_c('p',{class:['label-feedback', _vm.feedback.type]},[_vm._v(_vm._s(_vm.feedback.message))]):_vm._l((_vm.statuses),function(status){return _c('button',{key:status,on:{"click":function($event){return _vm.declare(status)}}},[_vm._v(_vm._s(_vm.i18n.statuses[status]))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }